import React from 'react';

export const ErrorBoundaryCheck = () => {
  const throwError = () => {
    throw new Error('Error check');
  };

  React.useEffect(() => {
    throwError();
  }, []);

  return (
    <div>
      <h1>Error Boundary Test</h1>
      <p>This should not be seen because of the exception thrown</p>
    </div>
  );
};
